import { differenceInCalendarDays } from 'date-fns'

import { PossibleOrderStatuses } from 'features/account/hm-pay/constants'

/**
 * getStatusType :: (bool, date) -> 'string'
 */
export default (orderStatus, dueDate): any => {
  const isOverDue = differenceInCalendarDays(new Date(), dueDate) > 0

  if (orderStatus === PossibleOrderStatuses.PAID) {
    return 'paid'
  }

  if (
    isOverDue &&
    ![
      PossibleOrderStatuses.PAYMENT_IN_PROGRESS,
      PossibleOrderStatuses.PAYMENT_SCHEDULED,
      PossibleOrderStatuses.PAUSED,
    ].includes(orderStatus)
  ) {
    return 'overdue'
  }

  return 'unpaid'
}
